import ID from './id.png'
import EN from './en.png'
import VI from './vi.png'
import HK from './hk.png'
import TH from './th.png'

export default {
  en: EN,
  sg: EN,
  my: EN,
  ph: EN,
  id: ID,
  vi: VI,
  hk: HK,
  tw: HK,
  th: TH,
}